const FlightsSameRoute = (state) => state.FlightsSameRoute
export default {
  FlightsSameRoute
}
